import ParticipantIds from '../enums/ParticipantIds';
import { SystemMessageType } from '../enums/Enum';

/**
 * Checks the last message from history in only refresh scenario
 * @param {any} msgObj message object
 */
const isLastMessage = function (msgObj) {
    if (!ApexChat.allHistoryMessages ||
        (ApexChat.allHistoryMessages && ApexChat.allHistoryMessages.length == 0)) {
        // if no messages in history that means message is from Predefined or message before chat start so set its always true
        return true;
    }
    const allChatMsgs = ApexChat.allHistoryMessages.filter(
        (message) => message.userId != ParticipantIds.pokeMessage &&
            message.userId != ParticipantIds.nonVisitorSystem
    );
    const lastMsg = allChatMsgs[allChatMsgs.length - 1];
    if (lastMsg) {
        const isSmsOptin = lastMsg.systemMessageType
            ? lastMsg.systemMessageType == SystemMessageType.SMSOptIn
            : false;
        if (isSmsOptin) {
            return true;
        }
    }

    const lastMsgId = allChatMsgs.length > 0 && allChatMsgs[allChatMsgs.length - 1].id;
    return lastMsgId == msgObj.id;
};
export default isLastMessage;
